import { Pipe, PipeTransform } from '@angular/core';
import { InstallationBobstContactPluginService } from './bobst-contact.service';

@Pipe({
    name: 'function',
    standalone: false
})
export class FunctionPipe implements PipeTransform {
  constructor(private service: InstallationBobstContactPluginService) {}

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.service.getFunctions());
  }
}
